
import { Component, Vue, Model } from "vue-property-decorator";
import AppCard from "@/modules/shared/components/AppCard.vue";
import AppInput from "@/modules/shared/components/AppInput.vue";
import { OpenIdModel } from "@flosum-auth/contracts/dist/open-id.contracts";

export type IdentityProvidersOpenIdInformationData = Pick<OpenIdModel, "clientId" | "clientSecret" | "issuer">;

@Component({
  components: {
    AppCard,
    AppInput,
  },
})
export default class IdentityProvidersOpenIdInformation extends Vue {
  @Model("changed")
  public readonly model!: IdentityProvidersOpenIdInformationData | null;

  public validator(value: string): string | true {
    return value.length ? true : "Value must be set!";
  }

  public getValue<K extends keyof IdentityProvidersOpenIdInformationData>(
    key: K,
    defaultValue: IdentityProvidersOpenIdInformationData[K]
  ): IdentityProvidersOpenIdInformationData[K] {
    return (this.model && this.model[key]) || defaultValue;
  }

  public update<K extends keyof IdentityProvidersOpenIdInformationData>(
    key: K,
    value: IdentityProvidersOpenIdInformationData[K]
  ): void {
    this.$emit("changed", {
      ...this.model,
      [key]: value,
    });
  }
}
